import { render, staticRenderFns } from "./OtherLogin.vue?vue&type=template&id=789af49e&scoped=true"
import script from "./OtherLogin.vue?vue&type=script&lang=js"
export * from "./OtherLogin.vue?vue&type=script&lang=js"
import style0 from "./OtherLogin.vue?vue&type=style&index=0&id=789af49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789af49e",
  null
  
)

export default component.exports